import { render, staticRenderFns } from "./Ysfpay.vue?vue&type=template&id=0efff5e2&scoped=true&"
import script from "./Ysfpay.vue?vue&type=script&lang=js&"
export * from "./Ysfpay.vue?vue&type=script&lang=js&"
import style0 from "./Ysfpay.vue?vue&type=style&index=0&id=0efff5e2&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0efff5e2",
  null
  
)

export default component.exports